<template>
  <div class="cui-login-wrapper">
    <section class="login-form-box">
      <header class="login-form-box-header">
        <div class="logo">
          <img src="@/assets/img/v2/navbar/logo.png" class="logo-hrcloud" />
          <span class="logo-line"></span>
          <img src="@/assets/img/main/logo-payroll-tax.png" class="logo-payroll-tax" />
        </div>
        <el-dropdown @command="handleCommand" placement="bottom" size="medium">
          <span class="el-dropdown-link pointer">
            {{ lang == 'zh' ? '中文' : 'English'  }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="item.value" v-for="item in language" :key="item.value">{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </header>
      <section class="login-form">
        <p class="login-form-title">{{ getLoginFormTitle }}</p>
        <div class="login-form-content">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" :status-icon="false" :show-message="false" v-show="step == 1">
            <el-form-item prop="username" class="item-user-password">
              <el-input size="medium" @keyup.enter.native="handleLogin" @change="getCus" v-model="loginForm.username" debounce="0" auto-complete="off" :placeholder="$t('logon.iptAccount')" />
            </el-form-item>
            <el-form-item prop="password" class="item-user-password">
              <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" :placeholder="$t('logon.iptPassword')">
                <i class="el-icon-view el-input__icon pointer" slot="suffix" @click="showPassword"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="code" style="text-align: left;" class="item-code" v-show="loginForm.loginType=='2'">
              <div class="flex acenter jbetween">
                <el-input size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.code" auto-complete="off" :placeholder="$t('logon.iptCheckcode')" />
                <el-image :src="codeImg.src" fit="cover" @click="refreshCode"></el-image>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="forget-item">
                <el-link type="info" :underline="false" @click="handleReister">{{$t("logon.register"/**注册*/)}}</el-link>
                <el-link type="info" :underline="false" @click="handleResetPwd">{{$t("logon.forgetPassword"/**忘记密码*/)}}</el-link>
                    <!--<el-link type="info" :underline="false" @click="dialogVisible = true">{{$t("logon.forgetPassword"/**忘记密码*/)}}</el-link>-->
                <div style="margin-top: 100px">
                  <el-dialog :visible.sync="dialogVisible" title="提示" width="30%" style="text-align: center;">
                    <span>请联系客服重置密码，联系电话400-026-8558-转5519</span>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                  </span>
                  </el-dialog>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="login-button-item">
              <el-button type="warning" :loading="loginLoading" size="medium" @click.native.prevent="handleLogin" class="login-submit">{{$t("logon.login")}}</el-button>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <div>
                <el-checkbox v-model="checked"></el-checkbox>
                <span style="color: #999;"> {{$t("logon.agree")}}</span>
                <a style="color: #1c1c1c; margin-left: 3px;" href="https://hrcloud.ciicpt.com.cn/ppolicy.html" target="_blank">
                  <i class="el-icon-d-arrow-left arrow arrow-left"></i>{{$t("logon.privacyPolicy")}}<i class="el-icon-d-arrow-right arrow arrow-right"></i>
                </a>
              </div>
            </el-form-item>
          </el-form>
          <ul class="select-enterprise pointer" v-show="step == 2" v-loading="loginLoading">
            <li class="enterprise-item" v-for="item in cusList" :key="`${ item.CUSID }-${item.CUSNAME}`" @click="handleSwitchCus(item)">{{ item.CUSNAME }}</li>
          </ul>
        </div>
      </section>
    </section>
    <section class="login-desc-box">
      <main class="login-desc-main">
        <div class="sys-name">
          <el-image style="height: 100%;" :src="require(`@/assets/img/v2/login/payroll-service-platform-${ lang }.png`)" fit="scale-down"></el-image>
        </div>
        <div class="payroll-text">
          <el-image style="width: 100%;" :src="require(`@/assets/img/v2/login/payroll-text-${ lang }.png`)" fit="scale-down"></el-image>
        </div>
        <a class="about-us" href="http://www.ciicpt.com.cn/">
          <el-image style="width: 100%; height: 100%;" :src="require(`@/assets/img/v2/login/aboutus-${ lang }.png`)" fit="scale-down"></el-image>
        </a>
      </main>
      <footer class="f-copyright">{{$t("logon.copyRight"/**版权所有*/)}}</footer>
    </section>
    <!--修改密码-->
    <update-password ref="updatePassword" @password-closed="updatePasswordClosed"></update-password>
  </div>
</template>

<script>
  import UpdatePassword from '@/page/login-v2/updatePassword';
  import {mapGetters} from 'vuex';
  import {randomLenNum, guid, encrypt, decrypt, dataToTree} from '@/util/util';
  import {validatenull} from '@/util/validate';
  import {setRem} from '@/util/commen';
  import {base64Encode} from '@/util/endecode';
  import hrCommon from '@/api/common/hrcloudCommon';
  import {getCusList, produceQrCode, wcLogin, switchCus} from '@/api/user/login';
  import store from '@/store';
  import { Message } from 'element-ui';

  export default {
    name: 'LoginV2',
    components: {
      UpdatePassword
    },
    data() {
      return {
        dialogVisible: false, // 控制对话框显示的变量
        codeImg: {
          src: '',
          value: '',
          len: 4,
          type: 'image',
        },
        loginMethod: 'code',
        language: [
          {value: 'zh', label: '中文'},
          {value: 'en', label: 'English'},
        ],
        checked: false,
        loginForm: {
          username: '',
          password: '',
          cusId: '',
          branchId: '',
          code: '',
          randomStr: '',
          loginType: '1', // 是否需要验证码，默认第一次登陆时是不需要验证码的，密码输入错误后，需要输入验证码
          codeKey: ''
        },
        loginRules: {
          username: [
            {required: true, message: this.$t('logon.iptAccount'), trigger: 'blur'},
          ],
          password: [
            {required: true, message: this.$t('logon.iptPassword'), trigger: 'blur'},
            {min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur'},
          ]
        },
        passwordType: 'password',
        loginLoading: false,
        step: 1
      }
    },
    watch: {
      $route(val) {
        if (this.accessToken) {
          this.step = val.query.step || 1;
        } else {
          this.step = 1;
        }
        this.loginLoading = false;
      }
    },
    created() {
      setRem();
      localStorage.setItem('version', this.$route.meta.version);
      this.refreshCode();
      // 语言设置
      const lang = localStorage.getItem('lang');
      if (lang) {
        this.$i18n.locale = lang;
      }
    },
    methods: {
      // 切换语言 step1
      handleCommand(command) {
        let lang = this.$i18n.locale;
        if (lang != command) {
          this.changeLaguages(command);
        }
      },
      // 切换语言 step2
      changeLaguages(lang) {
        this.$i18n.locale = lang;
        localStorage.setItem('lang', lang);
        this.$store.commit('CHANGE_LANG', lang)
        // 此处主要是翻译语言
        this.loginRules = {
          username: [
            {required: true, message: this.$t('logon.iptAccount'), trigger: 'blur'},
          ],
          password: [
            {required: true, message: this.$t('logon.iptPassword'), trigger: 'blur'},
            {min: 6, message: this.$t('logon.iptPasswordLen'), trigger: 'blur'},
          ]
        }
      },
      refreshCode() {
        this.loginForm.code = '';
        this.loginForm.codeKey = guid();
        this.loginForm.randomStr = randomLenNum(this.codeImg.len, true);
        this.codeImg.type == 'text'
          ? (this.codeImg.value = randomLenNum(this.codeImg.len))
          : (this.codeImg.src = `${hrCommon.HRCLOUD_URL}util/getVerifyCodeNew.action?codeKey=` + base64Encode(this.loginForm.codeKey)); //调用人事云接口获取 验证码
      },
      showPassword() {
         this.passwordType == '' ? (this.passwordType = 'password') : (this.passwordType = '');
      },
      // 点击登录
      handleLogin() {
        this.validate();
      },
      // 校验登录分离公共方法
      validate() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            if (/^\d+$/.test(this.loginForm.username)) {
              // 手机号
              this.loginForm.type = 2;
            } else if (this.loginForm.username.indexOf("@") != -1) {
              // 邮箱
              this.loginForm.type = 3;
            } else {
              // 用户名
              this.loginForm.type = 1;
              this.loginForm.username = this.loginForm.username
            }
            if (!this.checked) {
              Message({
                showClose: true,
                message: this.$t('logon.agreeMsg'),
                type: 'error'
              });
              return;
            }
            this.loginLoading = true;
            this.$store.dispatch('LoginByUsername', this.loginForm)
              .then((res) => {
                if (!res.data.success) {
                  this.loginLoading = false;
                  Message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                  });
                  this.loginRules.code = [
                    {required: true, message: this.$t('logon.iptCheckcode'), trigger: 'blur'},
                    {min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur'},
                  ];
                  this.loginForm.loginType = '2';
                  this.refreshCode();
                } else {
                  const {isInitPwd, isUpdatePwdTips} = res.data.data;
                  if (isUpdatePwdTips) {
                    this.$alert(this.$t('logon.passwordTipContent'), this.$t('logon.passwordTipTitle'), {
                      confirmButtonText: this.$t('determine'),
                      callback: action => {
                        this.alertCallback(action);
                      }
                    });
                  } else if (isInitPwd) {
                    this.$alert(this.$t('logon.updatePwdTipContent'), this.$t('logon.passwordTipTitle'), {
                      confirmButtonText: this.$t('determine'),
                      callback: action => {
                        this.alertCallback(action);
                      }
                    });
                  } else {
                    this.loginCallback(res);
                  }
                }
              })
              .catch((error) => {
                this.loginLoading = false;
                if (error.data && error.data.msg) {
                  Message({
                    showClose: true,
                    message: error.data.msg,
                    type: 'error'
                  });
                }
                this.loginRules.code = [
                  {required: true, message: this.$t('logon.iptCheckcode'), trigger: 'blur'},
                  {min: 4, max: 4, message: this.$t('logon.iptCheckcodeLen'), trigger: 'blur'},
                ];
                this.loginForm.loginType = '2';
                this.refreshCode();
              })
            }else{
              Message({
                showClose: true,
                message: "验证码不正确",
                type: 'error'
              });
            this.refreshCode();
          }
        });
      },
      /**
       * 登录成功回调
       *  1、只有1个客户时，密码提示后，直接跳转页面
       *  2、多个客户时，密码提示后，选择客户后，调用切换客户接口，再跳转页面
       * @param res
       */
      loginCallback(res) {
        const { cusList } = res.data.data;
        if (cusList && cusList.length > 1) {
          this.cusList = cusList;
          this.step = 2;
          this.$router.push({
            path: '/login',
            query: {
              step: 2
            }
          });
          setTimeout(() => {
            this.$store.commit('SET_ACCESS_TOKEN', '');
          },200)
        } else {
          this.redirectPath(res);
        }
      },
      // 登录成功，调用切换客户接口
      handleSwitchCus(cus) {
        this.loginLoading = true;
        const { CUSID, BRANCHID, CUSNAME, cusLogoUrl } = cus;
        const { access_token } = this.userInfo;
        this.$store.commit('SET_CUS_LOGO', cusLogoUrl);
        this.$store.commit('SET_ACCESS_TOKEN', access_token);
        const params = {
          cusId: CUSID,
          branchId: BRANCHID,
          cusName: CUSNAME
        }
        switchCus(params).then(res => {
          this.loginLoading = false;
          let resData = res.data.data;
          if (res.data.statusCode == 200) {
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.$store.commit('SET_ACCESS_TOKEN', resData.access_token);
              this.$store.commit('SET_REFRESH_TOKEN', resData.refresh_token);
              this.$store.commit('SET_CUS_ID', resData.cusId);
              this.$store.commit('SET_USER_INFO', resData);
              this.$store.commit('SET_BRANCH_INFO', {id: resData.branchId});
              this.$store.commit('SET_PMS', resData.pms);
              this.$store.commit('SET_AUTHORIZED_AGENCIES', resData.authorizedAgencies);
              this.$store.commit('SET_CUS_LIST', resData.cusList);
              this.$store.commit('CLEAR_LOCK');
              this.redirectPath(res);
            } else {
              this.$store.commit('SET_ACCESS_TOKEN', '');
              this.$message.error(res.data.msg);
            }
          } else {
            this.$store.commit('SET_ACCESS_TOKEN', '');
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$store.commit('SET_ACCESS_TOKEN', '');
          this.loginLoading = false;
        });
      },
      // 登录成功，跳转页面
      async redirectPath(res) {
        let userType = res.data.data.userType;
        let cusSourceType = res.data.data.cusSourceType;  // 0 老系统 1新系统
        if ("10620003" != userType) {
          // 当为HR时
          if ("1" == cusSourceType) {
            if (res.data.data.cusId == '1019672113180573696') {
              this.$router.push({path: '/nbqx/index.action'});
            } else {
              const hasZLPermission = this.pms[1].some(item => item.operateCode == 'hr_wage_new_report_data_center_zl')
              if (hasZLPermission) {
                this.$router.push({path: '/v2/stats/data-center-dashboard'});
              } else {
                this.$router.push({path: '/index'});
              }
            }

            this.$message.success('登录成功');
          } else {
            let hrUrl = hrCommon.HRCLOUD_URL + "secondMain.action?accessToken=" + base64Encode(encrypt(store.getters.accessToken, ''));
            window.location.href = hrUrl;
          }
        } else {
          // 雇员时，跳转到雇员端页面
          let empUrl = hrCommon.HRCLOUD_URL + "emp/index.action?accessToken=" + base64Encode(encrypt(store.getters.accessToken, ''));
          window.location.href = empUrl;
        }
      },
      // 忘记密码页面
      handleResetPwd() {
        let lang = localStorage.getItem('lang');
        let param = "";
        if (lang) {
          param = "?lang=" + base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL + "accountConfirmation.action" + param;
        window.open(hrcloudPath, "_blank")
      },
      // 注册页面
      handleReister: function () {
        let lang = localStorage.getItem('lang');
        let param = "";
        if (lang) {
          param = "?lang=" + base64Encode(lang)
        }
        var hrcloudPath = hrCommon.HRCLOUD_URL + "toRegister.action" + param;
        window.open(hrcloudPath, "_blank")
      },
      // 是否显示code码
      handleIsShowCode() {
        this.changeForm = !this.changeForm
        if (!this.changeForm) {
          produceQrCode().then(res => {
            if (res.data.msg === 'success') {
              this.codeImgSrc = res.data.data
            }
          })
        }

        if (this.changeForm) {
          return
        }
        var ws = new WebSocket("ws://2333e85t52.zicp.vip/chartServer/login");

        ws.onopen = (evt) => {
          console.log("Connection open ...");
          ws.send("Hello WebSockets!");
        };
        ws.onmessage = (evt) => {
          ws.close();
          if (evt.data.code == 0) {
            let params = {
              wxCode: evt.data.wxCode,
              state: evt.data.state
            }
            wcLogin(params).then(res => {

            })

          } else {
            this.$message(evt.data.msg);
            this.changeForm = true
          }
        };
        ws.onclose = function (evt) {
          console.log("Connection closed.");
        };
      },
      // 确认-显示修改密码弹窗 取消-清空缓存和token
      alertCallback(action) {
        if(action == 'cancel') {
          this.updatePasswordClosed();
        } else {
          this.$refs.updatePassword.visible = true;
        }
      },
      // 修改密码弹窗关闭，刷新登录页状态
      updatePasswordClosed() {
        this.checked = false;
        this.loginLoading = false;
        this.$store.dispatch('ClearCache');
      }
    },
    computed: {
      ...mapGetters(['lang', 'userInfo', 'accessToken', 'pms']),
      getLoginFormTitle() {
        let title = '';
        if (this.step == 1) {
          title = this.$t("logon.passwordLogin");
        }
        if (this.step == 2) {
          title = this.$t("logon.selectEnterprise")
        }
        return title;
      },
      cusList() {
        return this.userInfo.cusList;
      }
    }
  }
</script>
